import {
  Button,
  DateInput,
  DurationViewer,
  FixedScreenHeaderStack,
  Heading,
  SearchAndAddBar,
  useToast,
} from '~/common/components/defaultUIComponents';
import WorkingInfoApi from '~/common/api/zeiterfassungServerApi/WorkingInfoApi';
import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import React, { useCallback, useState } from 'react';
import { Flex } from '@chakra-ui/react';
import { format } from 'date-fns';
import axios from 'axios';

import { useEmployeesContext } from './state';
import { useStore } from 'zustand';

export const EmployeeHeader: React.FC = () => {
  const [loadingPdf, setLoadingPdf] = useState(false);
  const toast = useToast({ status: 'error', title: 'generic.error' });
  const employeeStore = useEmployeesContext();

  const {
    setSearchTerm,
    toggleAddEmployeeOpen: onToggle,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    toggleDeleteTimespanOpen,
  } = useStore(employeeStore);

  const [{ data: employees }] = EmployeeApi.hooks.useEmployeeQuery();
  const totalTime = WorkingInfoApi.hooks.useTotalWorkingTime(
    employees ?? [],
    dateFrom,
    dateTo,
    {
      enabled: !!employees,
    },
  );

  const fetchPdf = useCallback(() => {
    setLoadingPdf(true);
    axios
      .post<Blob>(
        '/pdf/employees/',
        {
          employees: employees?.map((e) => e.id),
          start: dateFrom.valueOf(),
          end: dateTo.valueOf(),
        },
        { responseType: 'blob' },
      )
      .then((res) => {
        const fileName = `Arbeiteszeiten_${format(
          dateFrom,
          'yyyy_MM_dd',
        )}_${format(dateTo, 'yyyy_MM_dd')}.pdf`;
        const link = document.createElement('a');
        const href = URL.createObjectURL(res.data);
        link.href = href;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(href);
      })
      .catch(toast)
      .finally(() => setLoadingPdf(false));
  }, [employees, dateFrom, dateTo]);

  return (
    <FixedScreenHeaderStack>
      <Heading>employees.heading</Heading>
      <SearchAndAddBar
        onInputChange={setSearchTerm}
        onClick={onToggle}
        inputPlaceholder="employees.searchProjects.input.placeholder"
        tooltipLabel="employees.addEmployee.tooltip.label"
      />
      <Flex alignItems="center">
        <DateInput
          label="employees.dateFilter.from"
          onChange={(e) => setDateFrom(e.target.valueAsDate ?? new Date())}
          row
          mr={2}
          defaultValueMilliseconds={dateFrom.valueOf()}
          useInFormik={false}
        />
        <DateInput
          label="employees.dateFilter.to"
          onChange={(e) => setDateTo(e.target.valueAsDate ?? new Date())}
          row
          defaultValueMilliseconds={dateTo.valueOf()}
          useInFormik={false}
          mr={2}
        />
        <DurationViewer
          label="employees.total.duration"
          durationInSeconds={totalTime}
        />
        <Button onClick={fetchPdf} isLoading={loadingPdf}>
          employees.pdf.exportButton.text
        </Button>
        <Button onClick={toggleDeleteTimespanOpen} ml={2}>
          employees.deleteTimespan.label
        </Button>
      </Flex>
    </FixedScreenHeaderStack>
  );
};
